<template>
  <v-card flat color="transparent">
    <v-card-text>
      <v-row
        v-for="filter in filters"
        :key="filter.filterKey"
      >
        <v-col cols="12" md="4">
          <v-row>
            <v-col
              cols="12">
              <v-select v-if="filter.source == 'input'"
                v-model="model[filter.filterKey]"
                @change="setAlgoliaFilters()"
                :label="filter.label"
                :items="filter.values"
                :loading="filter.loading"
                outlined
                dense
                clearable
                hide-details
                height=40                
                >
              </v-select>           
              <v-autocomplete-algolia
                v-else-if="filter.source == 'algolia'"
                v-model="model[filter.algoliaIndex]"
                :items="items[filter.algoliaIndex]"
                :handler="req => searchFilter(req, filter)"
                :delay="750"
                :label="filter.label"
                :index="filter.algoliaIndex"
                :loading="filter.loading"
                :multiple="filter.multiple"
                :attributesToHighlight="filter.fieldsToShow"
                :restrictSearchableAttributes="filter.fieldsToSearch"
                :item-text="filter.itemText"
                :no-data-text="filter.noDataText"
                :no-empty="filter.noEmpty"
                :chips="filter.chips"
                :deletable-chips="filter.deletableChips"
                :small-chips="filter.smallChips"
                @change="setAlgoliaFilters()"
                @update:search-input="filter.noDataText = $event ? $vuetify.noDataText : filter.noDataTextDefault"
                height=40
                no-filter
                hide-details
                return-object
                outlined
                dense
                clean
              >
                <template #item="{item}">
                  <div
                    v-for="(field, ix) in filter.fieldsToShow"
                    :key="field"
                  >
                    <span v-if="ix > 0" class="mx-1">-</span>
                    <span 
                      v-html="( 
                        item._highlightResult 
                        && item._highlightResult[field] 
                        && item._highlightResult[field].matchedWords
                        && item._highlightResult[field].matchedWords.length > 0
                      ) ? item._highlightResult[field].value : item[field]"/>
                  </div>
                </template>
                <template #selection>
                  <div class="d-none"></div>
                </template>
                <!-- <template v-if="filter.chips && filter.multiple" #selection="{ item, index, attrs, selected, disabled }">
                  <v-chip 
                    v-if="index < filter.formChips"
                    :key="JSON.stringify(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    :disabled="disabled"
                    :color="`${color} accent-4`"
                    small
                    close
                    dark
                    @click:close="(filter.multiple) ? parent.selectItem(item) : clearField({field: filter.value})"
                  >
                    <span>{{ filter.itemText ? filter.itemText.apply ?  filter.itemText(item) : item[filter.itemText] : item }}</span>
                  </v-chip>
                  <span
                    v-if="index == filter.formChips"
                    class="grey--text caption"
                  >(+{{ model[filter.algoliaIndex].length - filter.formChips }} outro(s))</span>
                </template> -->
              </v-autocomplete-algolia>
            </v-col>
          </v-row>
        </v-col>

      <!-- FILTROS ATIVOS -->
        <v-col cols="12" md="8">
          <v-row>
            <v-col
              v-show="filter.multiple ? model[filter.algoliaIndex].length > 0 : !!model[filter.algoliaIndex]"
              cols="12"
              class="pt-1"
              >
              <span v-text="filter.label + ':'" class="mr-2 caption"></span>
              <v-chip-group v-if="filter.multiple" column multiple max="0" class="mt--2">
                <v-chip
                  v-for="(item, idx) in model[filter.algoliaIndex]"
                  :key="filter.algoliaIndex + idx"
                  small
                  close
                  @click:close="removeFilterItem(filter, item)"
                  >
                  {{ filter.itemText ? filter.itemText.apply ? filter.itemText(item) : item[filter.itemText] : item }}
                </v-chip>
              </v-chip-group>
              <v-chip-group v-else-if="!!model[filter.algoliaIndex]" column multiple max="0" class="mt--2">
                <v-chip
                  small
                  close
                  @click:close="removeFilterItem(filter, model[filter.algoliaIndex])"
                  >
                  {{ filter.itemText ? filter.itemText.apply ? filter.itemText(model[filter.algoliaIndex]) : model[filter.algoliaIndex][filter.itemText] : model[filter.algoliaIndex] }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import VAutocompleteAlgolia from '@/components/VAutocompleteAlgolia'
export default {
  name: 'DataTableFilters',
  props: ['filters'],
  components: { VAutocompleteAlgolia },
  data() {
    return {
      items: {},
      model: {},
      algoliaFilters: [],
      chips: null
    }
  },
  computed: {
    isFiltered() {
      return this.filters.some(filter => {
        if (filter.multiple) {
          return this.model[filter.algoliaIndex].length > 0
        } else {
          return !!this.model[filter.algoliaIndex]
        }
      })
    },
  },
  created() {
    this.filters.forEach(async filter => {
      if (filter.source == 'collection') {
        /** @TODO */
        // const algoliaClient = algoliasearch(this.algolia?.appId, this.algolia?.searchApiKey)
        // const algoliaIndex = algoliaClient.initIndex(filter.collectionName)
        // try {
        //   filter.loading = true
        //   const response = await algoliaIndex.search()
          
        //   if (response?.hits) {
        //     filter.values = response.hits.map(hit => hit[filter.collectionField])
        //   } else {
        //     console.warn('Error in algolia search on filter ' + filter.name)
        //     filter.values = []
        //   }
        // } catch (err) {
        //   console.error(err)
        // } finally {
        //   filter.loading = false
        // }
      } else if (filter.source == 'algolia') {
        // v-model
        if (filter.multiple) {
          this.$set(this.model, filter.algoliaIndex, [])
        } else {
          this.$set(this.model, filter.algoliaIndex, null)
        }

        // prop items 
        this.$set(this.items, filter.algoliaIndex, [])

        
        // prop item-text
        filter.itemText = (item) => {
          if (!filter.fieldsToShow)
            return 'id'
          
          let str = item[filter.fieldsToShow[0]]
          filter.fieldsToShow.slice(1).forEach(field => {
            str = str + ' - ' + item[field]
          })

          return str
        }
        
        // prop no-data-text
        filter.noDataTextDefault = 'Digite algo para pesquisar'
        filter.noDataText = filter.noDataTextDefault

        // prop loading
        filter.loading = false
        
        if (filter.multiple) {
          filter.chips = true
          filter.deletableChips = true
          filter.smallChips = true
          filter.formChips = 1
        }
      }
    })
  },
  methods: {
    async searchFilter(req, filter) {
      filter.loading = true
      try {
        const { hits } = await req
        this.items[filter.algoliaIndex].splice(0)
        if (hits)
          this.items[filter.algoliaIndex].push(...hits)
      } catch (err) {
        console.error(err)
        this.items[filter.algoliaIndex].splice(0)
      } finally {
        filter.loading = false
      }
    },
    setAlgoliaFilters() {
      const algoliaFilters = []
      this.filters.forEach(filter => {  

        const prop = filter.algoliaIndex || filter.filterKey


        if (!this.model[prop])
          return

        if (filter.multiple) {          
          if (this.model[prop].length == 0) {
            return
          } else {            
            const arr = this.model[prop].map(item => `${filter.filterKey}:${filter.source == 'input' ? item : item[filter.itemKey] }`)
            algoliaFilters.push(arr)
          }
        } else {
          const value = filter.source == 'input' ? this.model[prop] : this.model[prop][filter.itemKey]
          algoliaFilters.push([`${filter.filterKey}:${value}`])
        }
      })
      this.algoliaFilters = algoliaFilters

      this.$emit('change', algoliaFilters)
    },
    removeFilterItem(filter, item) {
      if (filter.multiple) {
        const idx = this.model[filter.algoliaIndex].indexOf(item)
        this.model[filter.algoliaIndex].splice(idx, 1)
      } else {
        this.model[filter.algoliaIndex] = null
      }
      this.setAlgoliaFilters()
    },
  }
}
</script>

<style></style>